import {
    set,
    chain,
} from 'immutadot'
import {
    INIT_MEDIA_COLLABORATIVE_INDEXATIONS,
    SELECT_COLLABORATIVE_INDEXATION_ZONE,
    UNSELECT_COLLABORATIVE_INDEXATION_ZONE,
    SET_COLLABORATIVE_INDEXATION_CREATION_ZONE,
    DISPLAY_COLLABORATIVE_INDEXATIONS,
    HIDE_COLLABORATIVE_INDEXATIONS,
    INIT_COLLABORATIVE_INDEXATION_CAMPAIGN,
    UPDATE_COLLABORATIVE_INDEXATION_FIELD_VALUE,
    MOVE_TO_NEXT_COLLABORATIVE_INDEXATION_CREATION_STEP,
    MOVE_TO_PREVIOUS_COLLABORATIVE_INDEXATION_CREATION_STEP,
    CLOSE_COLLABORATIVE_INDEXATIONS_CREATION,
    OPEN_COLLABORATIVE_INDEXATIONS_CREATION,
    CANCEL_COLLABORATIVE_INDEXATIONS_CREATION_CLOSE,
    ENABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION,
    DISABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION,
    UNSET_COLLABORATIVE_INDEXATION_CREATION_ZONE,
    MOVE_TO_COLLABORATIVE_INDEXATION_STEP,
    INIT_COLLABORATIVE_INDEXATION_CREATION_FIELDS,
    SET_COLLABORATIVE_INDEXATION_INVALID_FIELDS,
    RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELDS,
    RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELD,
    OPEN_COLLABORATIVE_INDEXATION_SUMMARY,
    CLOSE_COLLABORATIVE_INDEXATION_SUMMARY,
    LOCK_COLLABORATIVE_INDEXATION_CREATION,
    UNLOCK_COLLABORATIVE_INDEXATION_CREATION,
} from './actions'

const initialState = {
    areDisplayed: false,
    isSummaryOpened: false,
    campaign: {},
    list: {},
    selectedZone: null,
    creation: {
        isLocked: false,
        currentStep: 1,
        isOpened: false,
        zone: null,
        selectionToolActive: false,
        fields: {},
        invalidFields: {}
    }
}

export const collaborativeIndexations = (state = initialState, { type, mediaUuid, collaborativeIndexations, collaborativeIndexation, indexationZone, field, collaborativeIndexationCampaign, step, ...action }) => {
    switch (type)
    {
        case INIT_COLLABORATIVE_INDEXATION_CAMPAIGN:
            return set(state, 'campaign', collaborativeIndexationCampaign)

        case DISPLAY_COLLABORATIVE_INDEXATIONS:
            return set(state, 'areDisplayed', true)

        case HIDE_COLLABORATIVE_INDEXATIONS:
            return chain(state)
                .set('areDisplayed', false)
                .set('selectedZone', null)
                .value()

        case INIT_MEDIA_COLLABORATIVE_INDEXATIONS:

            const collaborativeIndexationListToInit = { ...state.list }
            collaborativeIndexationListToInit[mediaUuid] = collaborativeIndexations

            return set(state, 'list', collaborativeIndexationListToInit)

        case SELECT_COLLABORATIVE_INDEXATION_ZONE:
            return set(state, 'selectedZone', indexationZone.uuid)

        case UNSELECT_COLLABORATIVE_INDEXATION_ZONE:
            return set(state, 'selectedZone', null)

        case OPEN_COLLABORATIVE_INDEXATIONS_CREATION:
            return set(state, 'creation.isOpened', true)

        case CLOSE_COLLABORATIVE_INDEXATIONS_CREATION:
            if(action.confirmed === false)
            {
                return set(state, 'creation.closeConfirmationNeeded', true)
            }

            return chain(state)
                .set('creation.isOpened', false)
                .set('creation.zone', null)
                .set('creation.fields', initialState.creation.fields)
                .set('creation.currentStep', initialState.creation.currentStep)
                .set('creation.closeConfirmationNeeded', false)
                .set('creation.selectionToolActive', false)
                .value()

        case CANCEL_COLLABORATIVE_INDEXATIONS_CREATION_CLOSE:
            return set(state, 'creation.closeConfirmationNeeded', false)

        case SET_COLLABORATIVE_INDEXATION_CREATION_ZONE:
            return set(state, 'creation.zone', indexationZone)

        case UNSET_COLLABORATIVE_INDEXATION_CREATION_ZONE:
            return set(state, 'creation.zone', null)

        case INIT_COLLABORATIVE_INDEXATION_CREATION_FIELDS:
            return set(state, 'creation.fields', action.fields)

        case UPDATE_COLLABORATIVE_INDEXATION_FIELD_VALUE:
            const fields = { ...state.creation.fields }
            fields[field.name] = field.value

            return set(state, 'creation.fields', fields)

        case MOVE_TO_NEXT_COLLABORATIVE_INDEXATION_CREATION_STEP:
            return set(state, 'creation.currentStep', state.creation.currentStep + 1)

        case MOVE_TO_PREVIOUS_COLLABORATIVE_INDEXATION_CREATION_STEP:
            return set(state, 'creation.currentStep', Math.max(1, state.creation.currentStep - 1))

        case MOVE_TO_COLLABORATIVE_INDEXATION_STEP:
            return set(state, 'creation.currentStep', Math.max(1, step))

        case ENABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION:
            return set(state, 'creation.selectionToolActive', true)

        case DISABLE_COLLABORATIVE_INDEXATION_CREATION_SELECTION:
            return set(state, 'creation.selectionToolActive', false)

        case SET_COLLABORATIVE_INDEXATION_INVALID_FIELDS:
            return set(state, 'creation.invalidFields', action.fields)

        case RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELDS:
            return set(state, 'creation.invalidFields', [])

        case RESET_COLLABORATIVE_INDEXATION_CREATION_INVALID_FIELD:
            const invalidFields = [...state.creation.invalidFields]
            const fieldIndex = invalidFields.indexOf(field);
            if(fieldIndex === -1)
            {
                return state
            }

            invalidFields.splice(fieldIndex, 1)

            return set(state, 'creation.invalidFields', invalidFields)

        case OPEN_COLLABORATIVE_INDEXATION_SUMMARY:
            return set(state, 'isSummaryOpened', true)

        case CLOSE_COLLABORATIVE_INDEXATION_SUMMARY:
            return set(state, 'isSummaryOpened', false)

        case LOCK_COLLABORATIVE_INDEXATION_CREATION:
            return set(state, 'creation.isLocked', true)

        case UNLOCK_COLLABORATIVE_INDEXATION_CREATION:
            return set(state, 'creation.isLocked', false)

        default:
            return state
    }
}
